import { ArticleFilter, ArticlesResponse } from '../types/articles';
import api from '../apis/constants';

// Lấy danh sách bài viết
const getArticles = async (filter: ArticleFilter) => {
    try {
        const response = await api.get('/articles/admin/all', { params: filter });
        const data = response.data;
        return {
            articles: data.articles || (data.data && data.data.articles) || [],
            total: data.total || (data.pagination && data.pagination.total) || 0,
            page: data.currentPage || (data.pagination && data.pagination.currentPage) || 1,
            limit: data.limit || (data.pagination && data.pagination.limit) || 10,
            totalPages: data.totalPages || (data.pagination && data.pagination.totalPages) || 1
        };
    } catch (error) {
        console.error('Error fetching articles:', error);
        throw error;
    }
};

// Lấy thông tin chi tiết bài viết
const getArticleById = async (id: string) => {
    try {
        const response = await api.get(`/articles/id/${id}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching article:', error);
        throw error;
    }
};

// Tạo bài viết mới
const createArticle = async (data: any) => {
    try {
        return await api.post('/articles', data);
    } catch (error) {
        console.error('Error creating article:', error);
        throw error;
    }
};

// Cập nhật bài viết
const updateArticle = async (id: string, data: any) => {
    try {
        const response = await api.patch(`/articles/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating article:', error);
        throw error;
    }
};

// Xóa bài viết
const deleteArticle = async (id: string) => {
    try {
        const response = await api.delete(`/articles/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting article:', error);
        throw error;
    }
};

export interface ArticleSelector {
  _id: string;
  title: string;
  type: string;
  featuredImage: {
    url: string;
    alt: string;
  };
}

export interface ArticlesSelectorResponse {
  status: string;
  data: ArticleSelector[];
}

const getArticleSelectors = async (): Promise<ArticlesSelectorResponse> => {
    try {
        const response = await api.get('/articles/selectors');
        return response.data;
    } catch (error) {
        console.error('Error fetching article selectors:', error);
        throw error;
    }
};

const articleService = {
    getArticles,
    getArticleById,
    createArticle,
    updateArticle,
    deleteArticle,
    getArticleSelectors,
};

export default articleService;
